<template>
  <v-snackbar
    v-model="isActive"
  >
    {{ $store.state.snackbar.text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="isActive = false"
      >
        Fermer
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'NotificationSnackbar',

  computed: {
    isActive: {
      get() {
        return this.$store.state.snackbar.isActive;
      },
      set(val) {
        this.$store.commit('SET_SNACKBAR', { isActive: val, text: '' });
      },
    },
  },
};
</script>
